<template>
  <button
    class="tab"
    :class="{'tab--active': isActive}"
    type="button"
    :disabled="isActive"
    @click="$emit('click')"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  name: 'step-counter',
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.tab {
  @include text-props(16, 20.8);

  padding: rem(8) rem(16);

  cursor: pointer;
  transition: 0.2s ease-in-out;

  color: #3D3D3D;
  border: none;
  border-radius: rem(8);
  background-color: $swans-down;

  &--active {
    cursor: default;

    color: #fff;
    background-color: $bondi-blue;
  }
}
</style>
